<div>
  <div class="d-flex flex-column align-items-center justify-content-center uploader" ondragover="return false;" [class.loaded]="loaded"
    [style.outlineColor]="dragging ? activeColor : baseColor" (dragenter)="handleDragEnter()"
    (dragleave)="handleDragLeave()" (drop)="handleDrop($event)">

    @if (files.length === 0) {
      <div class="uploader-hint text-center">
        <p class="mb-1">{{ 'BO_FILE_UPLOADER' | translate }}</p>
        <p class="text-muted mb-0">{{ 'BO_FILE_UPLOADER_SUPPORTED_LIST' | translate }}</p>
      </div>
    }

    @if (files.length > 0) {
      <div class="d-flex flex-wrap justify-content-center w-100">
        @for (file of files; track file) {
          <div class="file p-1 m-2 text-center" style="position: relative;">
            <img [src]="file.imgSource" (load)="handleImageLoad()" [class.loaded]="imageLoaded" />
            <button type="button" class="close position-absolute" aria-label="Close" (click)="removeAttachment($event, file)"
              style="top: 0; right: 0;">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="filename px-2">{{ file.fileName }}</div>
          </div>
        }
      </div>
    }

    <div class="inputButtonDiv mt-3">
      <button type="button" class="btn btn-upload" (click)="fileUpload.click()">
        {{ uploadButtonText | translate }} <i class="now-ui-icons files_single-copy-04 ml-2"></i>
      </button>
    </div>
  </div>

  <input id="fileInputDrag" type="file" name="file" onclick="this.value=null; return true;" [attr.multiple]="maxFiles === 1 ? null : true"
    (change)="handleInputChange($event)" #fileUpload />

  @if (uploaderError) {
    <div>
      <p class="uploadError">{{ 'BO_FILE_UPLOAD_ERROR' | translate }}</p>
    </div>
  }
</div>
